'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styledComponents = require('./styled-components.js');

var DisplayFieldWithLabel = function (props) {
    var label = props.label, data = props.data;
    return (React__default.createElement("div", { style: { width: '100%' } },
        React__default.createElement(styledComponents.Label, null, label),
        React__default.createElement(styledComponents.DashedDivider, null),
        data));
};

module.exports = DisplayFieldWithLabel;
